import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { B100, DN50A, DN60A, N0, N30, N50A, N60A } from '@atlaskit/theme/colors';
import { borderRadius, fontSize, gridSize } from '@atlaskit/theme/constants';
var spacingUnit = gridSize();
var fontSizeUnit = fontSize();
var elevations = {
  light: [N50A, N60A],
  dark: [DN50A, DN60A]
};

var getElevationStyleForMode = function getElevationStyleForMode(mode) {
  var colors = elevations[mode];
  return {
    boxShadow: "0 4px 8px -2px ".concat(colors[0], ", 0 0 1px ").concat(colors[1])
  };
};

export var buttonsContainerStyles = {
  display: 'flex',
  flexShrink: 0,
  marginTop: spacingUnit - 2,
  position: 'absolute',
  right: 0,
  top: '100%'
};
export var getButtonStyles = function getButtonStyles(mode) {
  return _objectSpread(_objectSpread({}, getElevationStyleForMode(mode)), {}, {
    borderRadius: spacingUnit / 2 - 1,
    boxSizing: 'border-box',
    fontSize: fontSizeUnit,
    width: spacingUnit * 4,
    zIndex: 200,
    '&:last-child': {
      marginLeft: spacingUnit / 2
    }
  });
};
export var editButtonStyles = {
  appearance: 'none',
  background: 'transparent',
  border: 0,
  display: 'block',
  lineHeight: 1,
  margin: '0',
  padding: '0',
  outline: '0',
  '&:focus + div': {
    border: "2px solid ".concat(B100),
    background: N0
  }
};
export var errorIconContainerStyles = {
  lineHeight: '100%',
  paddingRight: spacingUnit - 2
};
export var readViewContainerStyles = {
  display: 'flex',
  fontSize: fontSize(),
  lineHeight: spacingUnit * 2.5 / fontSizeUnit,
  maxWidth: '100%',
  minHeight: "".concat(spacingUnit * 2.5 / fontSizeUnit, "em"),
  padding: "".concat(spacingUnit, "px ").concat(spacingUnit - 2, "px"),
  '&[data-compact="true"]': {
    padding: "".concat(spacingUnit / 2, "px ").concat(spacingUnit - 2, "px")
  },
  wordBreak: 'break-word'
};
export var readViewContentWrapperStyles = {
  boxSizing: 'border-box',
  border: '2px solid transparent',
  borderRadius: borderRadius(),
  display: 'inline-block',
  maxWidth: '100%',
  transition: 'background 0.2s',
  width: 'auto',
  '&[data-read-view-fit-container-width="true"]': {
    width: '100%'
  },
  '&:hover': {
    background: N30
  }
};